module.exports = __webpack_public_path__ + "img/erplogo.ddf1dea8.png";